/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/card_medium'
export default icon
